import { NavLink, Outlet, useLocation } from "react-router-dom"
import { Button, Paper } from "@mui/material"

function Appointments() {
  const { pathname } = useLocation()

  return (
    <>
      <Paper paperVariant="menuContainerA">
        {["upcoming", "past"]?.map((element, i) => (
          <Button
            disableRipple
            LinkComponent={NavLink}
            key={`${element}-${i}`}
            to={`/specialist/profile/appointments/${element}`}
            sx={{
              textTransform: "capitalize",
              bgcolor: "transparent !important",
              color: pathname?.split("/")?.pop() === element ? "primary.main" : "other.color1",
            }}
          >{element}
          </Button>
        ))}
      </Paper>

      <Outlet />
    </>
  )
}

export default Appointments


// ["pending", "accepted", "past"]